// helpers/cubbyLifeHelpers.js

import { Cubby } from "../stores/Cubby";

export const waitForOnchainActions = async (cubby: Cubby) => {
  let attempts = 0;
  // console.log("Starting wait for allowOnchainActions...");

  while (!cubby.allowOnchainActions && attempts < 5) {
    // console.log(`Attempt ${attempts + 1}: Checking allowOnchainActions...`);
    cubby.cubbyLife("get_info");

    await new Promise((resolve) => setTimeout(resolve, 2000)); // Wait 2 seconds
    attempts++;
  }

  if (cubby.allowOnchainActions) {
    // console.log(
    //   "allowOnchainActions became true. Proceeding to get_onchain_balances and get_peers..."
    // );
    cubby.cubbyLife("get_onchain_balances");
    cubby.cubbyLife("get_peers");
  } else {
    console.log(
      "allowOnchainActions did not become true within 10 seconds. Stopping checks."
    );
  }
};

export const waitForBasicLightningApiRequests = async (cubby: Cubby) => {
  let attempts = 0;
  // console.log(
  //   "Starting wait for isConsideredReadyForBasicLightningApiRequests..."
  // );

  while (!cubby.isConsideredReadyForBasicLightningApiRequests && attempts < 5) {
    // console.log(
    //   `Attempt ${
    //     attempts + 1
    //   }: Checking isConsideredReadyForBasicLightningApiRequests...`
    // );
    cubby.cubbyLife("get_info");

    await new Promise((resolve) => setTimeout(resolve, 2000)); // Wait 2 seconds
    attempts++;
  }

  if (cubby.isConsideredReadyForBasicLightningApiRequests) {
    // console.log(
    //   "isConsideredReadyForBasicLightningApiRequests became true. Proceeding to get_channels..."
    // );
    cubby.cubbyLife("get_channels");
  } else {
    console.log(
      "isConsideredReadyForBasicLightningApiRequests did not become true within the additional 10 seconds. Stopping checks."
    );
  }
};
